import { normalizeBaseUrl } from "shared-utils";
import { Api as TitaniumApi } from "../generated/TitaniumApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const titaniumApi = new TitaniumApi({
  baseURL: normalizeBaseUrl(config.titaniumApiUrl),
});

createAxiosRequestInterceptors(titaniumApi.instance);

export default titaniumApi;
